export function toCsvBlob(csvOrCsvRows) {
    const csv = typeof csvOrCsvRows === 'string' ? csvOrCsvRows : csvOrCsvRows.map(rowToCsv).join('\n');
    return new Blob([
        csv
    ], {
        type: 'text/csv;charset=utf-8;'
    });
}
function rowToCsv(row) {
    return row.map(quoteCsvFields).join(',');
}
function quoteCsvFields(text) {
    return '"'.concat(('' + text).replace(/"/g, '""'), '"');
}
